import { css } from '@emotion/react';
import sctheme from 'app/styles/sctheme';

const styles = sctheme => css`
  @media (min-width: 721px) {
    height: 100vh;
  }

  .navigation-primary {
    padding-bottom: 20px;
  }

  .navigation {
    height: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    width: 250px;
    background-color: ${sctheme.white};
    overflow-y: auto;
    z-index: 1002;
    position: fixed;
    top: 0;
    transform: translateX(-250px);
    transition: transform 0.35s ease-in-out, box-shadow 0.35s ease-in-out;

    &.is-open {
      transform: translateX(0);
      box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 4px 8px rgba(16, 22, 26, 0.2),
        0 18px 46px 6px rgba(16, 22, 26, 0.2);
    }

    .admin-nav-collapse-toggle {
      @media (max-width: 1200px) {
        display: none;
      }
      width: 67px;
      height: 62px;
      position: sticky;
      top: 0;
      z-index: 10;
      cursor: pointer;
      text-align: center;
      background-color: #566068;
      margin-right: -67px;
      color: white;
    }

    .logo-nav-collapsed {
      @media (min-width: 1201px) {
        display: none;
      }
    }

    .collapsed-provider-info {
      @media (max-width: 1200px) {
        display: none;
      }
      opacity: 0;
      visibility: hidden;
      transition: opacity 0s step-start, visibility 0s step-start;
      left: 100px;
      display: flex;
      position: fixed;
      white-space: nowrap;
      color: white;
      font-weight: bold;
      padding-top: 15px;
      align-items: center;
    }

    &.collapsed .collapsed-provider-info {
      opacity: 1;
      visibility: visible;
      transition: opacity 0.25s ease-in-out, visibility 0.25s ease-in-out;
      transition-delay: 0.1s;
    }

    @media (min-width: 1200px) {
      flex-basis: 250px;
      overflow-x: visible;
      position: relative;
      transform: translateX(0);
      margin-top: -61px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
      transition: width 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

      &.is-open {
        transform: none;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
      }

      &.collapsed {
        width: 67px;
        transition: width 0.1s ease-in-out, box-shadow 0.1s ease-in-out;
      }

      .admin-nav-collapse-toggle {
        display: block !important;
        &:hover {
          background-color: #6d7780 !important;
        }

        .nav-collapse-icon {
          height: 1rem;
          width: auto;
          top: 50%;
          transform: translateY(-75%);
          position: relative;
        }
      }
    }
  }

  .navigation-secondary {
    padding-top: 20px;
    border-top: 1px solid ${sctheme.grays.$200};
  }

  .navigation .nav-link {
    color: ${sctheme.grays.$800};
    border-left: 3px solid transparent;
    padding: 15px;
  }

  .navigation .nav-link:hover {
    border-left-color: ${sctheme.blues.secondary};
    color: ${sctheme.grays.$800};
  }

  .navigation .nav-link.active {
    background-color: ${sctheme.grays.$100};
    border-left-color: ${sctheme.blues.secondary};
    color: ${sctheme.blues.secondary};
  }
`;

export default styles(sctheme);
